'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const EngagementChartInner = dynamic(() => import('./EngagementChartInner'), { ssr: false });

interface Props {
  pageId: string;
  platform: 'facebook' | 'instagram';
}

export default function EngagementChart({ pageId, platform }: Props) {
  return <EngagementChartInner pageId={pageId} platform={platform} />;
}